import axios from 'axios';
import Vue from 'vue';
import dateUtil from './date-util';

class ApiProxy {
  constructor({ baseURL }) {
    this._eventProxy = new Vue();

    this.AUTH_EXCEPTION = {
      NOT_LOGGED: 401001,
      INVALID_AUTH_INFO: 401002,
      NO_PERMISSION: 401004
    };

    this._axios = axios.create({
      method: 'post',
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      timeout: 120000,
      responseType: 'json',
      baseURL,
      // 扩展配置，表示请求时是否携带授权身份信息, 默认携带
      extWithAuth: true
    });

    this._axios.interceptors.request.use(conf => {
      if (!conf.headers) {
        conf.headers = {};
      }

      if (conf.extWithAuth) {
        if (!this._token) {
          this._emitAuthException(this.AUTH_EXCEPTION.NOT_LOGGED);
          return;
        }

        conf.headers.Authorization = `Bearer ${this._token}`;
      }

      conf.headers['ICEQERP-LANGUAGE'] = this._lang;
      conf.headers['ICEQERP-UTC-OFFSET-MINUTES'] = dateUtil.getUtcOffsetMinutes();
      return conf;
    });

    this._axios.interceptors.response.use(
      response => {
        const newAuthToken = response.headers && response.headers['iceqerp-auth-token'];
        if (newAuthToken) {
          this.setCertificate(newAuthToken);
        }
        if ((response && response.data && response.data.status === 0 && response.data.reason) || (response && response.data && !response.data.succeeded && response.data.reason)) {
          this._emitUnknownException(response.data.reason, response.data.message);
        }
        return response;
      },
      async (error) => {
        console.dir(error);

        const { response } = error;
        console.log('response', response.data, response.data.reason, response.data.message);

        if (response) {
          switch (response.status) {
            case 401: // Unauthorized
              this._emitAuthException(response.data.reason);
              break;
            default:
              var blob = response.data;
              if (blob instanceof Blob) {
                const text = await blob.text();
                const result = JSON.parse(text);
                this._emitUnknownException(result.reason, result.message);
              } else {
                this._emitUnknownException(response.data.reason, response.data.message);

              }
              break;
          }
        }
        throw error;
      });
  }

  setCertificate(token) {
    this._token = token;
  }

  getCertificate() {
    return this._token;
  }

  clearCertificate() {
    this._token = null;
  }

  setLang(lang) {
    this._lang = lang;
  }

  request(url, args, conf) {
    return this._axios.post(url, args, conf)
      .then((res) => res.data);
  }

  requestBlob(url, args, conf) {
    return this._axios.post(url, args, { ...conf, responseType: 'blob' })
      .then((res) => this._resolveBlobResponse(res));
  }

  listenAuthException(callback) {
    this._eventProxy.$on('AUTH_EXCEPTION', callback);
  }

  stopAuthException(callback) {
    this._eventProxy.$off('AUTH_EXCEPTION', callback);
  }

  listenUnknownException(callback) {
    this._eventProxy.$on('UNKOWN_EXCEPTION', callback);
  }

  stopUnknownException(callback) {
    this._eventProxy.$off('UNKOWN_EXCEPTION', callback);
  }

  _emitAuthException(code) {
    this._eventProxy.$emit('AUTH_EXCEPTION', { code });
  }

  _emitUnknownException(code, message) {
    this._eventProxy.$emit('UNKOWN_EXCEPTION', { code, message });
  }

  _resolveBlobResponse(res) {
    const type = res.headers['content-type'];
    const blob = new Blob([res.data], { type });
    const disposition = res.headers['content-disposition'];
    const nameStr = disposition && disposition.split(';')[1];
    let fileName;
    if (nameStr) {
      fileName = nameStr.split('=')[1];
    }

    if (fileName) {
      fileName = decodeURI(fileName);
    }

    return { blob, fileName };
  }
}

export default ApiProxy;